import isEmpty from 'lodash/isEmpty'
import React, { useState } from 'react'

import { identify } from '@Analytics/identify'
import { ButtonWithProgress } from '@Components/Button/ButtonWithProgress'
import { NativeModal, NativeModalBody, NativeModalHeader, useNativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import { useTranslation } from '@Globals/Translations'
import { EmailRegexValidation } from '@Shared/Components/Forms/Validations/EmailValidation'
import { TextInput } from '@Shared/Components/Inputs/TextInput/TextInput'

import styles from './styles.module.scss'

function requireEmail(value: any) {
  if (EmailRegexValidation(value)) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: 'validation:YOUR_EMAIL_IS_INVALID',
    success: false,
  }
}

function requireValue(value: any) {
  if (!isEmpty(value)) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: 'validation:EMAIL_REQUIRED_TEXT',
    success: false,
  }
}

const ClubVerification = ({
  actionRef,
  apply,
}: {
  actionRef: ReturnType<typeof useNativeModalActions>
  apply: (customerID: string) => Promise<{ errorMessage?: string, success: boolean }>
}) => {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [state, setState] = useState({ error: '', loading: false })

  const submit = async () => {
    setState({ error: '', loading: true })
    try {
      const customerID = await identify({ email, skipAmpliAwait: true })
      if (customerID) {
        const result = await apply(customerID)
        setState({ error: result.errorMessage || '', loading: false })

        if (result.success) {
          actionRef.current?.close()
        }
      }
    } catch (e) {
      setState({ error: e.message, loading: false })
    }
  }

  return (
    <NativeModal
      actionRef={actionRef}
      alignment="right"
      backdrop
      className={styles.clubVerification}
      onClose={() => {
        actionRef.current?.close()
      }}
    >
      <NativeModalHeader />
      <NativeModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            submit()
            return false
          }}
        >
          <h3>{t('cms:verify_title', { context: 'membership' })}</h3>
          <TextInput
            label={`${t('cms:WB_SIGNUP_EMAIL')} *`}
            onChange={setEmail}
            type="email"
            validations={[requireValue, requireEmail]}
            value={email}
          />
          <ButtonWithProgress
            className={styles.submitButton}
            disabled={!email || state.loading}
            loading={state.loading}
            type="submit"
          >
            {t('cms:verify_button', { context: 'membership' })}
          </ButtonWithProgress>
          {state.error && <p className={styles.error}>{state.error}</p>}
        </form>
      </NativeModalBody>
    </NativeModal>
  )
}

export default ClubVerification
